export default __webpack_public_path__ + "static/media/PPI-garden-bed-007.090d9162.jpg";